import CardInputGroup from '../../../../components/mazraeKit/CardInputGroup';
import useGetInputLists from '../../../../services/hookService/getInputLists/useGetInputLists';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
}
interface CategoryCardsProps<
  T extends {categories: Array<IFiltersKeyValuePairs>},
> {
  filters?: T;
  setFilters?: React.Dispatch<React.SetStateAction<T>>;
  chooseOneCard?: boolean;
  code?: number;
}
const InputLists = <T extends {categories: Array<IFiltersKeyValuePairs>}>({
  filters,
  setFilters,
  code,
}: CategoryCardsProps<T>) => {
  const {data: inputlists} = useGetInputLists({input_group__code: code});
  const choosingHandler = (inputGroupItem: IInputLists) => {
    const found = filters?.categories?.some(
      el => el.guid === inputGroupItem.guid,
    );
    if (found) {
      setFilters &&
        setFilters(prev => {
          return {
            ...prev,
            categories: prev.categories.filter(
              item => item.guid !== inputGroupItem.guid,
            ),
          };
        });
    } else {
      setFilters &&
        setFilters(prev => {
          return {
            ...prev,
            categories: [
              ...prev.categories,
              {guid: inputGroupItem.guid, title: inputGroupItem.title},
            ],
          };
        });
    }
  };

  return (
    <div className="grid-cols-4	grid px-3 w-full">
      {inputlists?.map(item => {
        return (
          <div className="flex w-full justify-center">
            <CardInputGroup
              isActive={filters?.categories?.some(
                el => el?.guid === item?.guid,
              )}
              isBoled={false}
              title={item.title}
              image={item.image}
              guid={item?.guid}
              clickHandler={() => choosingHandler(item)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default InputLists;
